import { useRouter } from "next/router";
import { useEffect, useState } from "react";

const useRouterChange = (
  setGlobalPrevRoute: (prevRoute: string) => void,
  currentPathRef: React.MutableRefObject<string>
) => {
  const router = useRouter();
  const [routeChanging, setRouteChanging] = useState(false);

  useEffect(() => {
    const handleRouteChangeStart = (url: string) => {
      setRouteChanging(true);
      const currentPath = currentPathRef.current;
      if (currentPath && currentPath !== url) {
        // Use global utility function
        setGlobalPrevRoute(currentPath);
      }
    };
    const handleRouteChangeEnd = () => {
      setRouteChanging(false);
    };
    router.events.on("routeChangeStart", handleRouteChangeStart);
    router.events.on("routeChangeComplete", handleRouteChangeEnd);

    return () => {
      router.events.off("routeChangeStart", handleRouteChangeStart);
      router.events.off("routeChangeComplete", handleRouteChangeEnd);
    };
  }, [router.events]);

  return routeChanging;
};

export default useRouterChange;
